var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"p-2 font-weight-bold",attrs:{"large":"","color":"primary","elevation":"0","loading":_vm.loadingServices},on:{"click":_vm.loadServices}},[_c('v-icon',{staticClass:"white--text",attrs:{"size":"24"}},[_vm._v("$plus")]),_vm._v(" "+_vm._s(_vm.$t('button.addNew'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }